/* SilverShine — PDP: galería, zoom, drawer de tallas, grabado,
   variantes (pills), sticky móvil. El añadir-al-carrito lo maneja
   product-form.js de Dawn (AJAX + drawer). */
(function () {
  'use strict';

  var RANGES = { ella: [4, 10], él: [8, 13], 'única': [4, 10] };

  /* Diámetro interior (mm) por talla US — MISMA tabla oficial que la página
     /pages/tu-talla-de-anillo (sección ss-tallas). Contorno = π·diámetro.
     Antes se calculaba con una fórmula (14.05 + 0.83·talla) que salía ~3 tallas
     corrida (talla 4 daba 17.4 mm en vez de 14.8). Ahora es la tabla fija. */
  var DIA = {
    '4': 14.8, '4.5': 15.2, '5': 15.7, '5.5': 16.1, '6': 16.5, '6.5': 16.9,
    '7': 17.3, '7.5': 17.7, '8': 18.1, '8.5': 18.5, '9': 19.0, '9.5': 19.4,
    '10': 19.8, '10.5': 20.2, '11': 20.6, '11.5': 21.0, '12': 21.4, '12.5': 21.8, '13': 22.2
  };

  function money(cents) {
    var el = document.querySelector('[data-ss-price]');
    var sample = el ? el.textContent.trim() : 'RD$ 0.00';
    var num = (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
    return sample.replace(/[\d.,]+/, num);
  }

  function init() {
    var root = document.querySelector('.ss-pdp');
    if (!root) return;
    var divisor = parseInt(root.dataset.cuotasDivisor || '6', 10);

    /* --- Galería: dots móvil + zoom --- */
    var gal = root.querySelector('[data-ss-gallery]');
    var dotsWrap = root.querySelector('[data-ss-dots]');
    if (gal && dotsWrap) {
      var slides = gal.querySelectorAll('.ss-pdp__slide');
      slides.forEach(function (s, i) {
        var d = document.createElement('span');
        d.className = 'ss-pdp__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
      });
      gal.addEventListener('scroll', function () {
        var idx = Math.round(gal.scrollLeft / gal.clientWidth);
        dotsWrap.querySelectorAll('.ss-pdp__dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }, { passive: true });
    }

    /* --- Galería piloto: tira de miniaturas --- */
    var thumbsWrap = root.querySelector('[data-ss-thumbs]');
    if (gal && thumbsWrap) {
      var thumbs = thumbsWrap.querySelectorAll('[data-ss-thumb]');
      var setActiveThumb = function (idx) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      };
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.ssThumb, 10) || 0;
          gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
          setActiveThumb(i);
        });
      });
      var thumbTick;
      gal.addEventListener('scroll', function () {
        if (thumbTick) return;
        thumbTick = requestAnimationFrame(function () {
          thumbTick = null;
          setActiveThumb(Math.round(gal.scrollLeft / gal.clientWidth));
        });
      }, { passive: true });
    }

    var zoom = root.querySelector('[data-ss-zoom]');
    root.querySelectorAll('[data-ss-zoom-src]').forEach(function (slide) {
      slide.addEventListener('click', function () {
        zoom.querySelector('img').src = slide.dataset.ssZoomSrc;
        zoom.classList.add('is-open');
      });
    });
    if (zoom) zoom.addEventListener('click', function () { zoom.classList.remove('is-open'); });

    /* --- Variantes modelo A+B: motor por opciones --- */
    var variantInput = root.querySelector('[data-ss-variant-id]');
    var optionsWrap = root.querySelector('[data-ss-options]');
    var variantsData = [];
    var dataEl = root.querySelector('[data-ss-variants-data]');
    if (dataEl) { try { variantsData = JSON.parse(dataEl.textContent); } catch (e) {} }

    function moneyFull(cents) {
      var el = root.querySelector('[data-ss-price]');
      var sample = el ? el.textContent.trim() : '$0.00';
      var num = (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
      return sample.replace(/[\d.,]+/, num);
    }
    function moneyDiff(cents) {
      return moneyFull(cents).replace(/\.00\b/, '');
    }
    function selectedOptions() {
      var out = [];
      optionsWrap.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
        out[parseInt(r.dataset.optionIndex, 10)] = r.value;
      });
      return out;
    }
    function findVariant(opts) {
      return variantsData.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function refreshVariantUI() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      var showDiff = optionsWrap.dataset.showDiff === 'true';

      optionsWrap.querySelectorAll('[data-ss-option-group]').forEach(function (group) {
        var idx = parseInt(group.dataset.ssOptionGroup, 10);
        var valEl = group.querySelector('[data-ss-option-value]');
        if (valEl && opts[idx]) {
          var checkedInput = group.querySelector('input:checked');
          valEl.textContent = ': ' + ((checkedInput && checkedInput.dataset.short) || opts[idx]);
        }
        var isDiffGroup = group.hasAttribute('data-ss-diff-group');
        group.querySelectorAll('.ss-var__pill').forEach(function (pill) {
          var input = pill.querySelector('input');
          if (!input) return;
          var candidate = opts.slice();
          candidate[idx] = input.value;
          var cv = findVariant(candidate);
          pill.classList.toggle('is-soldout', !cv || !cv.available);
          var diffEl = pill.querySelector('[data-ss-diff]');
          if (diffEl) {
            if (showDiff && isDiffGroup && cv && v && cv.id !== v.id && cv.price !== v.price) {
              var d = cv.price - v.price;
              diffEl.textContent = '· ' + (d > 0 ? '+' : '−') + moneyDiff(Math.abs(d));
              diffEl.hidden = false;
            } else {
              diffEl.hidden = true;
            }
          }
        });
      });

      if (!v) return;
      variantInput.value = v.id;
      var priceEl = root.querySelector('[data-ss-price]');
      var priceMini = root.querySelector('[data-ss-price-mini]');
      var priceTxt = moneyFull(v.price);
      var cuota = Math.round(v.price * 0.85 / 12 / 100) * 100;
      if (priceEl) priceEl.textContent = priceTxt;
      if (priceMini) priceMini.textContent = priceTxt;
      var cuotaEl = root.querySelector('[data-ss-cuota]');
      var cuotaMini = root.querySelector('[data-ss-cuota-mini]');
      if (cuotaEl) cuotaEl.textContent = money(cuota);
      if (cuotaMini) cuotaMini.textContent = money(cuota);
      var atc = root.querySelector('[data-ss-atc]');
      var atcLabel = root.querySelector('[data-ss-atc-label]');
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      }
      if (v.featured_media && v.featured_media.id) {
        var slide = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
      }
    }
    if (optionsWrap && variantsData.length) {
      optionsWrap.addEventListener('change', refreshVariantUI);
      refreshVariantUI();
    }

    /* --- Drawer de tallas --- */
    var drawer = root.querySelector('[data-ss-size-drawer]');
    var rowsWrap = root.querySelector('[data-ss-size-rows]');
    var whoEl = root.querySelector('[data-ss-drawer-who]');
    var currentWho = null;
    var chosen = {};

    /* Tallas en stock para marcar el selector con punto rose. El stock físico
       es de la variante en oro vermeil, así que solo aplica con ese acabado. */
    function vermeilSelected() {
      var radios = root.querySelectorAll('[data-ss-options] input[type="radio"]');
      if (!radios.length) return true;
      var has = {}, ok = {};
      radios.forEach(function (r) {
        if (!/vermeil/i.test(r.value)) return;
        var g = r.name || r.getAttribute('data-option-index') || '';
        has[g] = true;
        if (r.checked) ok[g] = true;
      });
      var groups = Object.keys(has);
      if (!groups.length) return true;
      return groups.every(function (g) { return ok[g]; });
    }
    function availableSizesFor(who) {
      var plata = !vermeilSelected();
      var single = root.querySelector('[data-ss-disp-reactivo]');
      if (single) return (single.getAttribute(plata ? 'data-tallas-plata' : 'data-tallas') || '').split('|').filter(Boolean);
      var set = root.querySelector('[data-ss-disp-set]');
      if (!set) return [];
      if (who === 'él' || who === 'el') return (set.getAttribute(plata ? 'data-pool-el-plata' : 'data-pool-el') || '').split('|').filter(Boolean);
      var piezas = (set.getAttribute(plata ? 'data-pool-ella-plata' : 'data-pool-ella') || '').split(';').filter(Boolean).map(function (s) { return s.split('|'); });
      if (!piezas.length) return [];
      return piezas[0].filter(function (t) { return piezas.every(function (arr) { return arr.indexOf(t) !== -1; }); });
    }

    function buildRows(who) {
      rowsWrap.innerHTML = '';
      var avail = availableSizesFor(who);
      var range = RANGES[who] || RANGES.ella;
      for (var v = range[0]; v <= range[1]; v += 0.5) {
        var dia = DIA[String(v)] || (11.51 + 0.822 * v);
        var inStock = avail.indexOf(String(v)) !== -1;
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'ss-size-drawer__row' + (chosen[who] === String(v) ? ' is-selected' : '') + (inStock ? ' is-stock' : '');
        row.dataset.size = v;
        row.innerHTML = '<span class="sz">' + v + '</span><span class="d">' + dia.toFixed(1) + '</span><span class="d">' + (dia * Math.PI).toFixed(1) + '</span><span class="radio"><span class="dot"></span></span>';
        row.addEventListener('click', (function (val) {
          return function () {
            chosen[who] = String(val);
            var valEl = root.querySelector('[data-ss-size-val="' + who + '"]');
            var inp = root.querySelector('[data-ss-size-input="' + who + '"]');
            if (valEl) { valEl.textContent = ': ' + val; valEl.classList.add('is-set'); valEl.classList.remove('ss-var__value--cta'); }
            if (inp) inp.value = val;
            document.dispatchEvent(new CustomEvent('ss:size', { detail: { who: who, value: String(val) } }));
            root.querySelectorAll('[data-ss-size-pick="' + who + '"]').forEach(function (p2) {
              p2.classList.toggle('is-selected', p2.dataset.size === String(val));
            });
            var need = root.querySelector('[data-ss-size-need]');
            if (need) need.hidden = true;
            rowsWrap.querySelectorAll('.ss-size-drawer__row').forEach(function (r2) {
              r2.classList.toggle('is-selected', r2.dataset.size === String(val));
            });
            setTimeout(closeDrawer, 350);
          };
        })(v));
        rowsWrap.appendChild(row);
      }
    }
    function setTab(tab) {
      drawer.querySelectorAll('[data-ss-tab]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.ssTab === tab); });
      drawer.querySelectorAll('[data-ss-tab-panel]').forEach(function (p) { p.hidden = p.dataset.ssTabPanel !== tab; });
    }
    function openDrawer(who, tab) {
      currentWho = who;
      if (whoEl) whoEl.textContent = who === 'única' ? 'Tu talla' : 'Talla de ' + who;
      buildRows(who);
      setTab(tab);
      drawer.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }
    root.querySelectorAll('[data-ss-size-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (e.target.closest('[data-ss-guide-open]')) return;
        openDrawer(btn.dataset.ssSizeOpen, 'select');
      });
      btn.addEventListener('keydown', function (e) {
        if (e.target.closest('[data-ss-guide-open]')) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        openDrawer(btn.dataset.ssSizeOpen, 'select');
      });
    });
    root.querySelectorAll('[data-ss-guide-open]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        e.stopPropagation();
        openDrawer(g.dataset.ssGuideOpen, 'guide');
      });
    });
    if (drawer) {
      drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
      drawer.querySelector('[data-ss-drawer-close]').addEventListener('click', closeDrawer);
      drawer.querySelectorAll('[data-ss-tab]').forEach(function (b) {
        b.addEventListener('click', function () { setTab(b.dataset.ssTab); });
      });
    }

    /* --- Validación de tallas antes de enviar --- */
    var form = root.querySelector('#ss-product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var missing = [];
        root.querySelectorAll('[data-ss-size-input]').forEach(function (inp) {
          if (!inp.value) missing.push(inp.dataset.ssSizeInput);
        });
        if (missing.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var need = root.querySelector('[data-ss-size-need]');
          if (need) {
            need.hidden = false;
            need.textContent = missing.length > 1 ? 'Elige ambas tallas para continuar.' : (missing[0] === 'él' ? 'Falta la talla de él.' : (missing[0] === 'ella' ? 'Falta la talla de ella.' : 'Elige la talla para continuar.'));
            need.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
          return false;
        }
        var label = root.querySelector('[data-ss-atc-label]');
        if (label) {
          var original = label.textContent;
          setTimeout(function () {
            label.textContent = 'Agregado a tu bolsa ✓';
            root.querySelector('[data-ss-atc]').classList.add('is-added');
            setTimeout(function () {
              label.textContent = original;
              root.querySelector('[data-ss-atc]').classList.remove('is-added');
            }, 2200);
          }, 600);
        }
      }, true);
    }

    /* --- Tallas: click directo en la píldora (sin pasar por el drawer) --- */
    root.querySelectorAll('[data-ss-size-pick]').forEach(function (pillBtn) {
      pillBtn.addEventListener('click', function () {
        var who = pillBtn.dataset.ssSizePick;
        var val = pillBtn.dataset.size;
        root.querySelectorAll('[data-ss-size-pick="' + who + '"]').forEach(function (p2) {
          p2.classList.toggle('is-selected', p2 === pillBtn);
        });
        var valEl = root.querySelector('[data-ss-size-val="' + who + '"]');
        if (valEl) { valEl.textContent = ': ' + val; valEl.classList.add('is-set'); valEl.classList.remove('ss-var__value--cta'); }
        var inp = root.querySelector('[data-ss-size-input="' + who + '"]');
        if (inp) inp.value = val;
        document.dispatchEvent(new CustomEvent('ss:size', { detail: { who: who, value: String(val) } }));
        if (typeof chosen === 'object') chosen[who] = String(val);
        var need = root.querySelector('[data-ss-size-need]');
        if (need) need.hidden = true;
      });
    });

    /* --- Grabado --- */
    var engrave = root.querySelector('[data-ss-engrave]');
    if (engrave) {
      engrave.querySelector('[data-ss-engrave-toggle]').addEventListener('click', function () {
        engrave.classList.toggle('is-open');
        engrave.querySelector('[data-ss-engrave-ico]').textContent = engrave.classList.contains('is-open') ? '−' : '+';
      });
      engrave.querySelectorAll('[data-ss-count]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          inp.parentElement.querySelector('[data-ss-count-val]').textContent = inp.value.length;
        });
      });
    }

    /* --- Sticky móvil --- */
    var sticky = root.querySelector('[data-ss-sticky]');
    if (sticky) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('is-stuck', window.scrollY > 520);
      }, { passive: true });
      var stickyBtn = sticky.querySelector('[data-ss-sticky-atc]');
      function missingSize() {
        var m = null;
        root.querySelectorAll('[data-ss-size-input]').forEach(function (inp) {
          if (!inp.value && !m) m = inp.dataset.ssSizeInput;
        });
        return m;
      }
      function refreshStickyLabel() {
        stickyBtn.textContent = missingSize() ? 'Elige tu talla' : 'Agregar';
      }
      refreshStickyLabel();
      root.addEventListener('click', function () { setTimeout(refreshStickyLabel, 50); });
      stickyBtn.addEventListener('click', function (e) {
        var m = missingSize();
        if (m) {
          e.preventDefault();
          openDrawer(m, 'select');
          return;
        }
      });
      sticky.querySelector('[data-ss-sticky-atc]').addEventListener('click', function () {
        if (missingSize()) return;
        if (form) {
          if (form.requestSubmit) form.requestSubmit(form.querySelector('[data-ss-atc]'));
          else form.querySelector('[data-ss-atc]').click();
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
